import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Col,
  Divider,
  Flex,
  Image,
  InputNumber,
  message,
  Row,
  Select,
  Space,
  Spin,
  Tag,
  Grid,
  List,
  Card,
  Badge,
  Typography,
  Empty,
  Result,
} from "antd";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import authCheck from "../../../APIs/authCheck";

import publicDataServices from "../../../APIs/publicDataServices";

import CarouselWithThumbnails from "../../../Components/Common/carouselWithThumbnails";

import { settings } from "../../../Services/apiSetting";
import { toSlug } from "../../../Components/Common/helpers";
import {
  addToCart,
  getDefaultSelectedOptions,
} from "../../../Components/Common/addToCart";

const { Option } = Select;
const { useBreakpoint } = Grid;

const { Title } = Typography;

const ProductDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();

  const [messageApi, contextHolder] = message.useMessage();

  const [isLoading, setLoading] = useState(true);

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [productDetails, setProductDetails] = useState(null);

  const [fileList, setFileList] = useState([]);
  const [moreFileList, setMoreFileList] = useState([]);
  const list = (moreFileList || []).slice(0, 4);

  const [randomProducts, setRandomProducts] = useState([]);

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [combinedCategories, setCombinedCategories] = useState([]);

  const { slug, sku, productId } = useParams();

  const [invalidProduct, setInvalidProduct] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const isOnlyNumbers = /^[0-9]+$/.test(productId);

        if (!isOnlyNumbers) {
          messageApi.error("No product found.");

          setInvalidProduct(true);

          getRandomProducts();

          return;
        }

        await Promise.all([
          fetchProductDetails(sku, productId),
          // fetchCategories(),
          // fetchSubCategories(),
        ]).then(([productDetails, categories, subCategories]) => {
          // console.log("Product details:", productDetails);

          const firstCategoryId =
            productDetails?.ProductSubCategoryLinks?.[0]?.ProductSubCategory
              ?.ProductCategoryId;

          // console.log("First category ID:", firstCategoryId);

          getRandomProducts(productDetails?.Id, firstCategoryId);

          // const combinedData = combineCategoriesAndSubcategories(
          //   categories,
          //   subCategories
          // );
          // console.log("Combined categories:", combinedData);
          // setCombinedCategories(combinedData);
        });
      } catch (error) {
        console.error("Error during data fetch:", error);
      } finally {
        setLoading(false);
      }
    };

    if (!productId) {
      messageApi.error("No product ID provided. Redirecting to products.");

      setInvalidProduct(true);

      setTimeout(() => {
        navigate("/products");
      }, 1000);

      return;
    } else {
      fetchData();
    }

    // if (!location.state?.productId) {
    //   messageApi.error("No product ID provided. Redirecting to products.");

    //   setTimeout(() => {
    //     navigate("/products");
    //   }, 1000);

    //   return;
    // }
  }, []);

  const fetchProductDetails = async (sku, productId) => {
    try {
      setInvalidProduct(false);

      const response = await publicDataServices.getProductById(productId);

      if (response?.status === 200) {
        const productData = JSON.parse(response.data.data);

        if (
          toSlug(productData.ProductName.toLowerCase()) !==
            toSlug(slug).toLowerCase() ||
          toSlug(productData.Sku.toLowerCase()) !== toSlug(sku).toLowerCase()
        ) {
          messageApi.error("No product found.");

          // setTimeout(() => {
          //   navigate(-1);
          // }, 1000);

          setInvalidProduct(true);

          return;
        }

        setProductDetails(productData);

        sessionStorage.setItem(
          "lastViewedProduct",
          JSON.stringify(productData),
        );

        if (productData.ImagesTag) {
          const imageNames = productData.ImagesTag
            ? productData.ImagesTag.split(";")
            : [];

          const files = imageNames.map((fileName) => ({
            uid: fileName,
            name: fileName,
            status: "done",
            url: settings.productImageFolder + fileName,
          }));

          setFileList(files);
        }

        if (productData.MoreInfoImagesTag) {
          const moreImageNames = productData.MoreInfoImagesTag
            ? productData.MoreInfoImagesTag.split(";")
            : [];

          const moreFiles = moreImageNames.map((fileName) => ({
            uid: fileName,
            name: fileName,
            status: "done",
            url: settings.productMoreInfoImageFolder + fileName,
          }));

          setMoreFileList(moreFiles);
        }

        setLoading(false);

        return productData;
      } else {
        messageApi.error("Failed to fetch product details.");

        // setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching product details:", error);

      messageApi.error(
        error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to fetch product details.",
      );

      setInvalidProduct(true);

      // navigate("/products");

      // setLoading(false);
    }
  };

  // const fetchCategories = async () => {
  //   try {
  //     const response = await publicDataServices.getCategories();

  //     if (response?.status === 200) {
  //       const categoryData = JSON.parse(response.data.data);

  //       setCategories(categoryData);

  //       return categoryData;
  //     } else {
  //       messageApi.error("Failed to fetch categories.");
  //     }
  //   } catch (error) {
  //     messageApi.error(
  //       error?.response?.data?.message ||
  //         error?.response?.data ||
  //         "Failed to fetch category."
  //     );
  //   }
  //   return [];
  // };

  // const fetchSubCategories = async () => {
  //   try {
  //     const response = await publicDataServices.getSubCategories();

  //     if (response?.status === 200) {
  //       const subCategoriesData = JSON.parse(response.data.data);

  //       const subs = subCategoriesData.SubCategories;

  //       setSubCategories(subs);

  //       return subs;
  //     } else {
  //       messageApi.error("Failed to fetch sub categories.");
  //     }
  //   } catch (error) {
  //     messageApi.error(
  //       error?.response?.data?.message ||
  //         error?.response?.data ||
  //         "Failed to fetch sub category."
  //     );
  //   }
  //   return [];
  // };

  // const combineCategoriesAndSubcategories = (categories, subCategories) => {
  //   const subCategoryMap = subCategories.reduce((acc, subCat) => {
  //     if (!acc[subCat.ProductCategoryId]) {
  //       acc[subCat.ProductCategoryId] = [];
  //     }
  //     acc[subCat.ProductCategoryId].push(subCat);
  //     return acc;
  //   }, {});

  //   return categories.map((category) => ({
  //     ...category,
  //     ProductSubCategories: subCategoryMap[category.Id] || [],
  //   }));
  // };

  //#region Add To Cart
  useEffect(() => {
    setSelectedOptions(getDefaultSelectedOptions(productDetails));
  }, [productDetails]);

  const [selectedOptions, setSelectedOptions] = useState({});
  const [quantity, setQuantity] = useState(1);

  // useEffect(() => {
  //   if (productDetails?.ProductOptions?.length) {
  //     const defaults = {};
  //     productDetails.ProductOptions.forEach((option) => {
  //       if (option.ProductOptionValues?.length) {
  //         defaults[option.OptionName] = option.ProductOptionValues[0].ValueName;
  //       }
  //     });
  //     setSelectedOptions(defaults);
  //   }
  // }, [productDetails]);

  // const normalizeOptions = (opts) => {
  //   if (!opts) return {};

  //   return Object.keys(opts)
  //     .sort()
  //     .reduce((acc, k) => {
  //       acc[k.trim().toLowerCase()] = String(opts[k]).trim();

  //       return acc;
  //     }, {});
  // };

  // const areOptionsExactlyEqual = (a, b) => {
  //   const na = normalizeOptions(a);
  //   const nb = normalizeOptions(b);
  //   const ak = Object.keys(na);
  //   const bk = Object.keys(nb);

  //   if (ak.length !== bk.length) return false;

  //   return ak.every((k) => k in nb && na[k] === nb[k]);
  // };

  // const handleAddToCart = () => {
  //   console.log("Selected options before normalization:", selectedOptions);

  //   const normalizedSelected = normalizeOptions(selectedOptions);

  //   console.log("Normalized selected options:", normalizedSelected);

  //   var specialKey =
  //     Object.entries(normalizedSelected)
  //       .map(([key, value]) => `${key}: ${value}`)
  //       .join("") + productDetails.Id;

  //   const cartItem = {
  //     productId: productDetails.Id,
  //     productName: productDetails.ProductName,
  //     descriptions: productDetails.Description,
  //     sku: productDetails.Sku,
  //     quantity,
  //     firstImage: fileList?.[0]?.url ?? null,
  //     options: normalizedSelected,
  //     specialKey,
  //   };

  //   const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];

  //   // Only merge when productId AND ALL options match.
  //   const idx = cartItems.findIndex(
  //     (item) =>
  //       item.productId === cartItem.productId &&
  //       areOptionsExactlyEqual(item.options, cartItem.options),
  //   );

  //   if (idx > -1) {
  //     // Exact same variant → just bump quantity
  //     cartItems[idx].quantity += quantity;

  //     messageApi.success({
  //       content: "Product quantity updated successfully!",
  //       duration: 2,
  //     });
  //   } else {
  //     // Different in at least one option → keep as separate line item
  //     cartItems.push(cartItem);

  //     messageApi.success({
  //       content: "Product added to cart successfully!",
  //       duration: 2,
  //     });
  //   }

  //   localStorage.setItem("cartItems", JSON.stringify(cartItems));

  //   window.dispatchEvent(new Event("cartUpdated"));
  // };
  //#endregion

  //#region Fetch Other Products
  const getRandomProducts = async (productId) => {
    try {
      setRandomProducts([]);

      const response = await publicDataServices.getRandomProducts(productId);

      // console.log(
      //   "getRandomProducts response:",
      //   JSON.parse(response.data.data)
      // );

      if (response.data.statusCode === 200) {
        const data = JSON.parse(response.data.data);

        setRandomProducts(data.products);
      }
    } catch (error) {
      console.error("Error fetching random products:", error);

      messageApi.error(
        error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to fetch random products",
      );
    }
  };

  //#endregion

  return (
    <Space
      direction="vertical"
      className="page-container"
      style={{
        paddingBottom: 0,
        marginBottom: 0,
      }}
    >
      {contextHolder}

      {isLoading ? (
        <div
          style={{
            width: "100%",
            height: "80vh",
          }}
        >
          <Spin
            spinning={isLoading}
            indicator={<LoadingOutlined spin />}
            fullscreen
          />
        </div>
      ) : (
        <>
          {invalidProduct ? (
            <Result
              style={{
                marginTop: screens.xs ? 10 : 40,
              }}
              status="404"
              title="404"
              subTitle="Sorry, the product does not exist."
              extra={
                <Button
                  type="primary"
                  style={{
                    color: "black",
                  }}
                  onClick={() => navigate("/products")}
                >
                  Back to Products
                </Button>
              }
            />
          ) : (
            <>
              {/* Product Details Section */}
              <Flex
                justify="center"
                wrap
                style={{
                  width: "100%",
                  gap: screens.xs ? 10 : 30,
                  marginTop: screens.xs ? 20 : 40,
                  marginBottom: 20,
                }}
              >
                <CarouselWithThumbnails fileList={fileList} />

                <div style={{ maxWidth: 500, width: "100%" }}>
                  <Flex
                    direction="column"
                    justify="flex-start"
                    align="center"
                    wrap="wrap"
                    style={{
                      marginBottom: 20,
                      gap: 10,
                    }}
                  >
                    <h2
                      style={{
                        color: "#002753",
                        fontWeight: "bold",
                        fontSize: 24,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      {productDetails?.ProductName}{" "}
                    </h2>

                    <p
                      style={{
                        color: "#9CA3AF",
                        fontSize: 14,
                        fontWeight: "normal",
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      SKU: {productDetails?.Sku}
                    </p>
                  </Flex>

                  <Flex
                    align="center"
                    wrap="wrap"
                    juistify="flex-start"
                    style={{
                      marginBottom: 10,
                      gap: 10,
                    }}
                  >
                    {productDetails?.ProductSubCategoryLinks.map((cat) => (
                      <Tag
                        key={"sub" + cat.ProductSubCategory.Id}
                        style={{
                          border: "none",
                          borderRadius: 25,
                          backgroundColor: "#f2f4f7",
                          padding: "5px 8px",
                        }}
                      >
                        <span
                          style={{
                            color: "black",
                            fontSize: 12,
                            fontWeight: 500,
                          }}
                        >
                          {cat.ProductSubCategory.SubCategoryName}
                        </span>
                      </Tag>
                    ))}
                  </Flex>

                  <Flex gap={8} align="center" style={{ width: "100%" }} wrap>
                    <p
                      style={{
                        fontWeight: "600",
                        height: 21,
                        fontSize: 16,
                      }}
                    >
                      {productDetails?.IsActive ? (
                        <span>
                          <CheckCircleFilled
                            style={{
                              marginRight: 5,
                              color: "#22C55E",
                            }}
                          />{" "}
                          In Stock
                        </span>
                      ) : (
                        <span>
                          <CloseCircleFilled
                            style={{
                              marginRight: 5,
                              color: "#EF4444",
                            }}
                          />{" "}
                          Out of Stock
                        </span>
                      )}
                    </p>
                  </Flex>

                  {productDetails?.PromotionProducts?.length > 0 && (
                    <Flex vertical gap={12} style={{ marginTop: 5 }}>
                      {productDetails.PromotionProducts.map((promo, index) => {
                        const promotion = promo?.Promotion;
                        if (!promotion) return null;

                        const hasDiscount = promotion.DiscountPercent > 0;
                        const hasBuyFree =
                          promotion.FreeItem > 0 && promotion.BuyQuantity > 0;

                        return (
                          <div key={index}>
                            {/* Promotion Name */}
                            {promotion.Name && (
                              <div
                                className="promo-title"
                                onClick={() => {
                                  navigate(
                                    `/promotion-details/${
                                      promotion.Id
                                    }/${toSlug(promotion.Name)}`,
                                  );
                                }}
                              >
                                {promotion.Name}
                              </div>
                            )}

                            {/* Promotion Badges */}
                            <Flex gap={8} align="center">
                              {hasDiscount && (
                                <div
                                  style={{
                                    height: 21,
                                    background: "#FFDC00",
                                    padding: "2px 10px",
                                    fontWeight: "bold",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
                                    borderRadius: 4,
                                    color: "black",
                                    fontSize: 12,
                                  }}
                                >
                                  {promotion.DiscountPercent}% OFF
                                </div>
                              )}

                              {hasBuyFree && (
                                <div
                                  style={{
                                    height: 21,
                                    background: "#FFDC00",
                                    padding: "2px 10px",
                                    fontWeight: "bold",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
                                    borderRadius: 4,
                                    color: "black",
                                    fontSize: 12,
                                  }}
                                >
                                  Buy {promotion.BuyQuantity} Free{" "}
                                  {promotion.FreeItem}
                                </div>
                              )}
                            </Flex>
                          </div>
                        );
                      })}
                    </Flex>
                  )}

                  <p
                    style={{
                      color: "#374151",
                      marginTop: 15,
                      marginBottom: 20,
                      fontWeight: "500",
                      fontSize: 14,
                      color: "#002753",
                      lineHeight: "1.5",
                      fontWeight: "600",
                    }}
                  >
                    {productDetails?.Description}
                  </p>

                  {/* Key Specifications */}
                  <Space
                    direction="vertical"
                    style={{
                      padding: 20,
                      backgroundColor: "#f2f4f7",
                      width: "100%",

                      marginTop: 0,
                      borderRadius: 10,
                    }}
                  >
                    <p
                      style={{
                        color: "#002753",
                        fontWeight: "500",
                        fontSize: 16,
                      }}
                    >
                      Key Specifications
                    </p>

                    <Divider style={{ margin: 0 }} />

                    {productDetails?.ProductOptions.map((option) => {
                      const {
                        Id,
                        OptionName,
                        OptionType,
                        ProductOptionValues,
                      } = option;

                      // Default value is the first option's ValueName (if exists)
                      // const defaultValue =
                      //   ProductOptionValues.length > 0
                      //     ? ProductOptionValues[0].ValueName
                      //     : undefined;

                      if (
                        OptionType === "select" ||
                        OptionType === "dropdown"
                      ) {
                        return (
                          <div key={Id} style={{ marginBottom: 5 }}>
                            <label
                              style={{
                                color: "#374151",
                                fontWeight: "500",
                              }}
                            >
                              {OptionName.charAt(0).toUpperCase() +
                                OptionName.slice(1)}
                              :
                            </label>

                            <br />

                            <Select
                              style={{ width: "100%" }}
                              defaultValue={ProductOptionValues[0]?.ValueName}
                              onChange={(value) => {
                                setSelectedOptions((prev) => ({
                                  ...prev,
                                  [OptionName]: value,
                                }));
                              }}
                              disabled={productDetails?.IsActive ? false : true}
                            >
                              {ProductOptionValues.map((value) => (
                                <Option
                                  key={value.Id}
                                  value={value.ValueName}
                                  disabled={value.InStock ? false : true}
                                >
                                  {value.ValueName}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        );
                      }
                    })}
                  </Space>

                  {/* Quantity Selector */}
                  <Flex
                    align="center"
                    style={{
                      marginTop: 15,
                      marginBottom: 15,
                    }}
                  >
                    <p>Quantity</p>

                    <InputNumber
                      min={1}
                      max={100}
                      defaultValue={1}
                      style={{
                        padding: 0,
                        marginLeft: 10,
                        borderRadius: 5,
                        width: 60,
                      }}
                      value={quantity}
                      onChange={(value) => setQuantity(value)}
                      controls={false}
                    />
                  </Flex>

                  <Flex align="center">
                    <Button
                      block
                      type="primary"
                      style={{
                        backgroundColor: "#002753",
                        borderColor: "#002753",
                        color: "white",
                      }}
                      // onClick={handleAddToCart}
                      onClick={() =>
                        addToCart({
                          productDetails,
                          selectedOptions,
                          quantity,
                          fileList,
                          messageApi,
                        })
                      }
                      disabled={productDetails?.IsActive ? false : true}
                    >
                      <ShoppingCartOutlined /> Add to Cart
                    </Button>
                  </Flex>
                </div>
              </Flex>

              {/* More info images */}
              <div
                className="more-info-wrap"
                style={{
                  paddingLeft: screens.md ? 30 : 0,
                  paddingRight: screens.md ? 30 : 0,
                }}
              >
                {list.length ? (
                  <div className="more-info-scroll">
                    <div className="more-info-block">
                      <Title
                        level={5}
                        className="more-info-title"
                        style={{
                          width: "100%",
                          color: "#002753",
                          fontWeight: "bold",
                          fontSize: 16,
                          marginBottom: 10,
                        }}
                      >
                        More Info
                      </Title>

                      <Row
                        gutter={[12, 12]}
                        wrap={false}
                        className="more-info-row"
                      >
                        {list.map((file, idx) => (
                          <Col
                            key={file?.id ?? file?.url ?? idx}
                            className="more-info-col"
                          >
                            <div className="more-info-imgBox">
                              <Image src={file?.url} />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </div>
                ) : (
                  <Empty description="No files" />
                )}
              </div>
            </>
          )}

          {/* Other products */}
          <Flex
            wrap
            vertical
            justify="center"
            align="center"
            style={{
              width: "100%",
              marginTop: screens.xs ? 20 : 40,
              marginBottom: screens.xs ? 20 : 40,
              paddingLeft: screens.md ? 30 : 0,
              paddingRight: screens.md ? 30 : 0,
            }}
          >
            <p
              style={{
                width: "100%",
                color: "#002753",
                fontWeight: "bold",
                fontSize: 16,
                marginBottom: 10,
              }}
            >
              You May Also Be Interested In
            </p>

            <List
              locale={{ emptyText: "No product(s) available." }}
              grid={{
                gutter: 16,
                xs: 2, // 1 column on extra small
                sm: 2, // 2 columns on small
                md: 2, // 3 columns on medium and up
                lg: 2, // 4 columns on large and up
                xl: 4,
                xxl: 4,
              }}
              dataSource={randomProducts}
              renderItem={(item) => {
                let splitImages = item.ImagesTag.split(";").map((img) =>
                  img.trim(),
                );

                return (
                  <List.Item>
                    {(() => {
                      const card = (
                        <Card
                          styles={{
                            body: {
                              paddingTop: 10,
                              paddingBottom: 20,
                              paddingLeft: screens.xs ? 10 : "auto",
                              paddingRight: screens.xs ? 10 : "auto",
                              width: "100%",
                            },
                          }}
                          style={{
                            minHeight: screens.xs ? 220 : 250,
                            borderRadius: 8,
                          }}
                          hoverable={false}
                          cover={
                            <Image
                              width={screens.xs || screens.md ? "100%" : 240}
                              height={200}
                              alt={item.ProductName}
                              style={{
                                borderRadius: 4,
                                overflow: "hidden",
                                objectFit: "contain",
                              }}
                              src={settings.productImageFolder + splitImages[0]}
                            />
                          }
                        >
                          <Typography.Paragraph
                            ellipsis={{
                              rows: 2,
                              tooltip: item.ProductName,
                            }}
                            style={{
                              width: "100%",
                              minHeight: 50.5,
                              margin: 0,
                              fontSize: 16,
                              color: "#002753",
                              fontWeight: "bold",
                            }}
                          >
                            {item.ProductName}
                          </Typography.Paragraph>

                          <Button
                            type="primary"
                            block
                            style={{
                              marginTop: 10,
                              backgroundColor: "#002753",
                              color: "#fff",
                            }}
                            className="view-details-btn"
                            onClick={() => {
                              navigate(
                                `/product/${toSlug(item.ProductName)}/${toSlug(
                                  item.Sku,
                                )}/${item.Id}`,
                              );

                              window.scrollTo(0, 0);

                              setLoading(true);

                              window.location.reload();
                            }}
                          >
                            View Details
                          </Button>
                        </Card>
                      );

                      // wrap with ribbons
                      let wrapped = card;

                      if (item.Promotions && item.Promotions.length > 0) {
                        wrapped = (
                          <div style={{ position: "relative" }}>
                            <div
                              style={{
                                position: "absolute",
                                top: 10,
                                left: -12,
                                background: "#FFDC00",
                                color: "#fff",
                                padding: "2px 10px",
                                transform: "rotate(-45deg)",
                                fontWeight: "bold",
                                zIndex: 1,
                                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                                borderRadius: 4,
                                color: "black",
                              }}
                            >
                              Promo
                              {/* {item.Promotions[0].DiscountPercent}% OFF */}
                            </div>

                            {wrapped}
                          </div>
                        );
                      }

                      if (item.RibbonText) {
                        wrapped = (
                          <Badge.Ribbon text={item.RibbonText} color="red">
                            {wrapped}
                          </Badge.Ribbon>
                        );
                      }

                      return wrapped;
                    })()}
                  </List.Item>
                );
              }}
            />
          </Flex>

          {/* Contact Us */}
          <Flex
            wrap
            vertical={screens.xs ? true : false}
            justify="center"
            align="center"
            style={{
              width: screens.xs || screens.md ? "100%" : "80%",
              marginBottom: screens.xs ? 40 : 60,
              marginLeft: "auto",
              marginRight: "auto",
              borderRadius: 12,
              backgroundColor: "#E5E7EB",
              padding: 20,
            }}
          >
            <Space direction="vertical" align="flex-start">
              <p
                style={{
                  color: "#002753",
                  fontWeight: "bold",
                  fontSize: 16,
                  marginBottom: 0,
                }}
              >
                Need assistance or a custom solution?
              </p>

              <p
                style={{
                  color: "#374151",
                  fontSize: 14,
                  marginBottom: 0,
                }}
              >
                Our experts are here to help you with project advice or product
                selection.
              </p>
            </Space>

            <Button
              block={screens.xs ? true : false}
              type="primary"
              style={{
                marginLeft: screens.xs ? "auto" : "auto",
                marginRight: screens.xs ? "auto" : 0,
                marginTop: screens.xs ? 20 : 0,
                backgroundColor: "#002753",
                borderColor: "#002753",
                color: "white",
              }}
              onClick={() => {
                navigate("/contact-us", {
                  state: { from: location.pathname },
                });
              }}
            >
              Contact Us
            </Button>
          </Flex>
        </>
      )}
    </Space>
  );
};

export default ProductDetails;
